module.exports = __webpack_public_path__ + "media/images/logo-large@2x-806af2b67b7453370149b81540a260fd.png";